import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiUrlHelper } from '../api-url-helper';
import { VideoTransFormer } from '../../_transformers/video.transformer';
import { BehaviorSubject } from '../../../../node_modules/rxjs';
import { HttpClientHelper } from '../http-helper';
import { Utility } from '../utility';
import { map, delay } from 'rxjs/operators';

@Injectable()
export class FavoriteService {

    private _favoriteStatusService = new BehaviorSubject<any>({});
    favoriteStatusSource$ = this._favoriteStatusService.asObservable();

    constructor(
        private _apiUrlHelper: ApiUrlHelper,
        private _videoTransFormer: VideoTransFormer,
        private _httpClientHelper: HttpClientHelper,
        private _utility:Utility
    ) {
    }

    changeFavoriteStatus(value) {
        this._favoriteStatusService.next(value);
    }

    getFavoriteUpdates(user): Observable<any> {

        const apiURL = this._apiUrlHelper.urlBuilder('user-favorite-updates', {
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
        });
        return this._httpClientHelper.get(apiURL)
            .pipe(map(res => {
                return {
                    total: res.length,
                    items: res.map(i => {
                        return this._videoTransFormer.transformFromFavoriteList({
                            lastName: i.lastName,
                            title: i.title,
                            secretVID: i.url,
                        });
                    })
                };
            }));
    }

    getFavoriteAttentionNotify(user): Observable<any> {

        const apiURL = this._apiUrlHelper.urlBuilder('user-favorite-attention-notify', {
        });
        return this._httpClientHelper.get(apiURL)
            .pipe(map(res => {
                return {
                    total: res.length,
                    items: res,
                };
            }));
    }

    getFavoriteNotify(): Observable<any> {

        const apiURL = this._apiUrlHelper.urlBuilder('get-favorite-notify', {
        });
        return this._httpClientHelper.get(apiURL)
            .pipe(map(res => {
                return {
                    total: res.length,
                    items: res,
                };
            }));
    }

    getAttentionNotify(): Observable<any> {

        const apiURL = this._apiUrlHelper.urlBuilder('get-attention-notify', {
        });
        return this._httpClientHelper.get(apiURL)
            .pipe(map(res => {
                return {
                    total: res.length,
                    items: res,
                };
            }));
    }

    updateFavoriteAttentionNotify(id, msgtype, actType): Observable<any> {

        const apiURL = this._apiUrlHelper.urlBuilder('update-favorite-attention-notify', {
            id: id,
            msgtype: msgtype,
            actType: actType,
        });
        return this._httpClientHelper.get(apiURL)
            .pipe(map(res => {
                return res[0];
            })).pipe(delay(200));
    }

    getFavorites(user, page, size, orderBy, Desc, cid, toBeContinued, filter, isPrivate): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('user-favorites', {
            pageIndex: page,
            pageSize: size,
            key: orderBy,
            order: Desc ? 'DESC' : 'ASC',
            cinema: cid === '7' || cid === '8' ? cid : '1',
            cid: cid !== '7' && cid !== '8' ? cid : '',
            serial: toBeContinued.toString(),
            search: filter,
            issecret: isPrivate,
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
        }, this._utility.isNews ? "NEWS_ENDPOINT" : "");
        return this._httpClientHelper.get(apiURL)
            .pipe(map(res => {
                return {
                    count: res[0]['count'],
                    items: res[0]['result'].map(f => {
                        return this._videoTransFormer.transformFromFavoriteList(f);
                    })
                };
            }));
    }

    removeFavoritesItem(user, item: String, isNews = false): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('video-remove-favorite', {
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
            videoid: item
        }, (isNews || this._utility.isNews) ? "NEWS_ENDPOINT" : "");
        return this._httpClientHelper.get(apiURL)
            .pipe(map(res => {
                return res;
            })).pipe(delay(200));
    }

    removeFavoritesItems(user, items: String[], cid): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('remove-user-favorites', {
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
            favoriteids: items.join(','),
            cinema: !!cid ? cid : null,
        }, this._utility.isNews ? "NEWS_ENDPOINT" : "");
        return this._httpClientHelper.get(apiURL)
            .pipe(map(res => {
                return res[0];
            })).pipe(delay(200));
    }

    clearFavorites(user): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('clear-user-favorites', {
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
        });
        return this._httpClientHelper.get(apiURL)
            .pipe(map(res => {
                return res[0];
            })).pipe(delay(200));
    }

    clearFavoritesUpdates(user): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('clear-favorite-updates', {
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
        });
        return this._httpClientHelper.get(apiURL)
            .pipe(map(res => {
                return res[0];
            })).pipe(delay(200));
    }

    clearFavoritesAttentionsUpdates(user, type = null): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('clear-favorite-attention-updates', {
            msgType: type,
        });
        return this._httpClientHelper.get(apiURL)
            .pipe(map(res => {
                return res[0];
            })).pipe(delay(200));
    }

    getPrivateFolderSettings(user): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('get-private-folder-settings', {
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
        });
        return this._httpClientHelper.get(apiURL)
            .pipe(map(res => {
                return res[0];
            }));
    }

    checkPrivateSecret(user, secret): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('check-private-secret', {
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
            Password: secret,
        });
        return this._httpClientHelper.get(apiURL)
            .pipe(map(res => {
                return res[0];
            }));
    }


}
